<template>
  <div id="app">
    <div id="loading" :hidden="!loading" class="overlay" style="height: 100%">
      <h1 class="loading">Chargement en cours <span>.</span><span>.</span><span>.</span></h1>
    </div>
    <div v-if="errorHandling" id="errorHandling" class="error">
      <div class="center justify-ceter align-center">
        <h1 class="h3n mb4">
          Désolé, une erreur technique s'est produite.
        </h1>
        <div class="relative center p2">
          <a
            :href="`${alphaDomain}`"
            class="py2 px3 center white red-bg full-height border-none caps"
            style="max-width: 200px"
          ><b>Retourner à l'ucpa</b></a>
        </div>

        <div v-if="dev" class="m3 p3 flex flex-column" style="border: 2px dotted black">
          <div class="">
            <div class="h3n py1 bold flex justify-center">Informations de débogage</div>
            <div class="h6n py1 bold flex justify-center">Uniquement disponible en recette</div>
            <div class="py2 flex justify-center">
              <div class="h6n">{{ errorHandling }}</div>
            </div>
            <span
              class="flex justify-center pointer py2 px3 white red-bg caps"
              @click="cleanError"
            ><b>nettoyer</b>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loaded">
      <div v-if="showImpersonateBanner && user && siteInfo" class="white red-bg py1 center sticky top-0 z4">
        Vous êtes connecté pour le compte de: {{ user.firstname }} {{ user.lastname }} sur le site {{ siteInfo.site_name }}
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import { getSiteDetail, getExpressCheckoutWorkspace } from '@/utils/requests';
import { moveTo404 } from '@/utils/utils';

export default {
  data () {
    return { loaded: false };
  },
  computed: {
    user () {
      return this.$store.state.user;
    },
    showImpersonateBanner () {
      return this.$store.getters.isImpersonateMode;
    },
    siteInfo () {
      return this.$store.state.siteInfo;
    },
    loading () {
      return this.$store.state.loading;
    },
    alphaDomain () {
      const { site_preroute, site_url } = this.$store.state.siteInfo;
      const { impersonateData } = this.$store.state;
      return `${process.env.VUE_APP_UCPA_DOMAIN}/${site_preroute}/${site_url}?impersonateData=${impersonateData}`;
    },
    errorHandling () {
      return this.$store.state.error;
    },
    dev () {
      return process.env.VUE_APP_ENVIRONMENT !== 'production';
    }
  },
  async mounted () {
    this.$store.commit('setImpersonateData', this.$route.query.impersonateData || this.$store.state.impersonateData);
    let workspace = this.$route.query.workspace || this.$store.getters.workspace;
    const base = process.env.BASE_URL || '/loisirs-reservation/';
    const pathWithoutBase = window.location.pathname.replace(base, '/').replace('//', '/');
    const resolvedName = this.$router.resolve(pathWithoutBase).name;
    const isCoupeFile = ['CoupeFileTDA', 'CoupeFileConfirmation'].includes(resolvedName);

    // Coupe file: workspace may only be available via httpOnly cookie (Sharegroop redirect has no query param)
    if (!workspace && isCoupeFile) {
      console.log('[App.vue] No workspace in query/store for coupe-file route, fetching from context...');
      try {
        const resp = await fetch('/loisirs-reservation/api/express-checkout/context', { credentials: 'same-origin' });
        const { success, workspace: ctxWorkspace } = await resp.json();
        if (success && ctxWorkspace) {
          workspace = ctxWorkspace;
        }
      } catch (_err) { /* proceed without workspace */ }
    }

    if (!workspace) {
      import('./assets/css/sportstation.css');
      this.loaded = true;
      return moveTo404();
    }

    const site = isCoupeFile
      ? await getExpressCheckoutWorkspace(workspace)
      : await getSiteDetail({ workspace: workspace });

    if (site) {
      if (site.site_preroute === 'sport-station') {
        import('./assets/css/sportstation.css');
      } else {
        import('./assets/css/centresportif.css');
      }

      this.setFavicon(site.site_preroute);

      // TODO -> CREATE SCHEMA ON API
      // this.$store.commit('setSiteInfo', { site_preroute: site.site_preroute, site_url: site.siteUrl, workspace: site.workspace, parceledMinimumAmount: site.parceledMinimumAmount, site_name: site.name, maintenance: site.maintenance, calendarMonths: site.calendarMonths, participantQuantityChanger: site.participantQuantityChanger });
      this.$store.commit('setSiteInfo', site);
    } else {
      import('./assets/css/sportstation.css');
    }

    this.loaded = true;
    return undefined;
  },
  methods: {
    cleanError () {
      this.$store.commit('resetError');
    },
    setFavicon (site_preroute = '') {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }

      if (site_preroute === 'formations') {
        link.href = 'favicon_red.ico';
      } else {
        link.href = 'favicon_violet.ico';
      }
    }
  }
};
</script>

<style lang="scss">
  /* Imports of static css files */
  @import './assets/css/common.css';

  /* fixes auto fill chrome styles */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: inherit;
    -webkit-box-shadow: none;
    transition: background-color 5000s ease-in-out 0s;
  }

  .ucpa-CartMember-total {
    font-size: 2.5rem;
  }

  @media(max-width: 52em) {
    .ucpa-CartMember-total {
      font-size: 1.3rem;
    }
  }

  .cartfield {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    height: 3.125rem;
    border: 1px solid #c8cdd2;
    border-radius: 0;
    padding: 0 0.9375rem;
    padding-right: 3rem;
  }

  .overlay {
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0, 0.5);
  }

  .loading {
    z-index: 9999;
    color: white;
    text-align: center;
    vertical-align: middle;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .loading span {
    animation-name: blink;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
  }

  .loading span:nth-child(2) {
    animation-delay: .2s;
  }

  .loading span:nth-child(3) {
    animation-delay: .4s;
  }

  @keyframes blink {
    0% {
      opacity: .2;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: .2;
    }
  }

  /* REQUIRED DOCUMENTS Card */
  .contact-card {
    height: 220px;
    color: #666;
    border-radius: 10px;
  }

  .lg-contact-card {
    color: #666;
    border-radius: 10px;
  }

  .valid-user-tag {
    margin-top: -3rem;
    border-radius: 0 10px 0 0;
  }

  // Loading animation
  .loading-animate {
  display: flex;
  animation-delay: 1s;

  .dot {
    position: relative;
    border-radius: 50%;

    &::before {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      background: inherit;
      border-radius: inherit;
      animation: wave 2s ease-out infinite;
    }
  }
}

@keyframes wave {
  50%,
  75% {
    transform: scale(1.5);
  }

  80%,
  100% {
    opacity: 0;
  }
}

.error {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  background-color: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
